import { Platform, View } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { Redirect } from 'expo-router'
import { Tabs } from 'expo-router/js-tabs'
import { AccountTabBar } from '@/src/components/navigation/AccountTabBar'
import { BottomNavIcon } from '@/src/components/ui/BottomNavIcon'
import { ScreenLoadingFallback } from '@/src/components/ui/ScreenLoadingFallback'
import { useAppSession } from '@/src/contexts/AppSessionContext'
import { colors } from '@/src/theme'
import { useTranslation } from 'react-i18next'

export default function DashboardLayout() {
  const insets = useSafeAreaInsets()
  const {
    isAccessPending,
    isLoading: isAuthenticating,
    requiresPostPaymentOnboarding,
  } = useAppSession()
  const { t } = useTranslation([
    'dashboard',
    'library',
    'statistics',
    'profile',
    'common',
  ])
  const isTabContentLoading = isAuthenticating || isAccessPending

  if (requiresPostPaymentOnboarding) {
    return <Redirect href="/post-payment-onboarding" />
  }

  return (
    <View className="flex-1">
      <Tabs
        tabBar={(tabBarProps) => <AccountTabBar {...tabBarProps} />}
        screenLayout={({ children }) => {
          if (isTabContentLoading) {
            return (
              <View className="flex-1 bg-background-primary">
                <ScreenLoadingFallback />
              </View>
            )
          }

          return (
            <View className="flex-1 bg-background-primary">{children}</View>
          )
        }}
        screenOptions={{
          lazy: false,
          headerShown: false,
          tabBarActiveTintColor: colors.primary,
          tabBarInactiveTintColor: colors.muted,
          tabBarShowLabel: true,
          tabBarStyle: {
            borderTopWidth: 1,
            borderTopColor: colors.border,
            backgroundColor: colors.background,
            ...Platform.select({
              default: {
                height: 72 + insets.bottom,
                paddingTop: 8,
                paddingBottom: insets.bottom,
              },
            }),
          },
          tabBarLabelStyle: {
            fontSize: 12,
            fontWeight: '500',
          },
        }}
      >
        <Tabs.Screen
          name="index"
          options={{
            title: t('dashboard:title'),
            tabBarLabel: t('dashboard:title'),
            tabBarIcon: ({ color, size }) => (
              <BottomNavIcon name="dashboard" size={size} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="statistics"
          options={{
            title: t('statistics:title'),
            tabBarLabel: t('statistics:title'),
            tabBarIcon: ({ color, size }) => (
              <BottomNavIcon name="statistics" size={size} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="library"
          options={{
            title: t('library:title'),
            tabBarLabel: t('library:title'),
            tabBarIcon: ({ color, size }) => (
              <BottomNavIcon name="library" size={size} color={color} />
            ),
          }}
        />
        <Tabs.Screen
          name="settings"
          options={{
            title: t('profile:title'),
            tabBarLabel: t('profile:title'),
            tabBarIcon: ({ color, size }) => (
              <BottomNavIcon name="settings" size={size} color={color} />
            ),
          }}
        />
      </Tabs>
    </View>
  )
}
